import { useState, useEffect } from "react";
import { login } from "../services/userService";
import { useNavigate } from "react-router-dom";
import { useUser } from "../contexts/UserContext";
import { useModal } from "../contexts/ModalContext";


type LoginProps = {
  onClose?: () => void;
};
const Login: React.FC<LoginProps> = ({ onClose }) => {
  const { login: userLogin } = useUser();
  const { openModal } = useModal();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (localStorage.getItem("user")) {
      navigate("/dashboard");
    }
  }, [navigate]);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    if (submitted) return;
    setSubmitted(true);
    setError("");

    try {
      const userData = await login(email, password);
      if (userData) {
        userLogin(userData);
        window.alert("Login successful!")
        if (onClose) onClose();
      }
    } catch {
      setError("Login failed. Please check your credentials.");
      setSubmitted(false);
    }
  };

  return (
    <form className="custom-form" onSubmit={handleLogin}>
      <div className="field-wrapper">
        <label htmlFor="email">
          Email
        </label>
        <input
          id="email"
          name="email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="name@company.com"
          required
        />
      </div>

      <div className="field-wrapper">
        <label htmlFor="password">
          Password
        </label>
        <input
          id="password"
          name="password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="••••••••"
          required
        />
      </div>

      {error && (
        <p className="error-message text-center">{error}</p>
      )}

      <button
        type="submit"
        disabled={submitted}
        className="custom-btn w-full"
      >
        {submitted ? "Logging in..." : "LOGIN"}
      </button>

      <p className="text-sm text-gray-500 text-center mt-4">
        Not registered?{" "}
        <button
          onClick={(e: React.FormEvent) => {
            e.preventDefault();
            openModal("register");
          }}
          className="text-primary hover:underline"
        >
          Create account
        </button>
      </p>
      
    </form>
  );
};

export default Login;